import { useHead, useRoute } from '#imports'

import keysByRoute from '~/translations/keys-by-route.json'

import { PROCESS_KEY } from '../constants'
import { getTranslationsScript } from '../utils/getTranslationsScript'

import { useIsTranslationsSplitV2Enabled } from './useIsTranslationsSplitV2Enabled'
import { useVisitedRoutes } from './useVisitedRoutes'

/**
 * From the server, it injects, in the HTML response, the script to populate the window.__BackmarketTranslations object which contains translations for the browser
 * If translations-split-v2 is enabled, it injects the translations of the current route (+ shared translations)
 * If not, it injects all the translations of the application
 * @param locale - fr-FR, en-US, etc.
 */
export function useInjectTranslationsScriptInHead(locale: string) {
  const translationsSplitV2Enabled = useIsTranslationsSplitV2Enabled()

  if (translationsSplitV2Enabled) {
    const route = useRoute()

    // if the route is not found, routeName is '__route-not-found__' for explicitness
    const routeName = String(route.name || '__route-not-found__')

    const { visitRoute } = useVisitedRoutes()
    const translationScript = getTranslationsScript({
      locale,
      routeName,
      translationKeysByRoute: keysByRoute,
    })

    visitRoute(routeName)

    useHead({
      script: [
        {
          // after main entry file (seems to be 100)
          tagPriority: 110,
          key: 'translations',
          innerHTML: translationScript,
        },
      ],
    })
  } else {
    const translationScript =
      globalThis[PROCESS_KEY].translationsInlineCode[locale]

    if (translationScript === undefined) {
      throw new Error(
        '[nuxt-module-i18n] Cannot retrieve translations for current locale',
      )
    }
    useHead({
      script: [
        {
          // after main entry file (seems to be 100)
          tagPriority: 110,
          key: 'translations',
          innerHTML: translationScript,
        },
      ],
    })
  }
}
